// Copyright (c) 2020 Deere & Company

import PinSearchResultData, { getDefaultState } from '../../shared/state/product';
import actions from '../../../../sharedmodules/actions-list';

const getPinSearchData = (state, action) => PinSearchResultData.update(state, {
    $set: action.data.pin !== '' ? action.data : getDefaultState(),
});

const resetPinSearchData = (state) => PinSearchResultData.update(state, {
    $set: getDefaultState(),
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.GET_PIN_SEARCH_DATA]: getPinSearchData,
        [actions.RESET_PIN_SEARCH_DATA]: resetPinSearchData,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
